import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchData } from "../../../utils/functions"; // adjust path

import GeneralInformation from "./tabs/GeneralInformation";
import FeatureDetails from "./tabs/FeatureDetails";
import ImplementationAndPhsyical from "./tabs/ImplementationAndPhsyical";
import  VerificationChecklist from "./tabs/VerificationChecklist";
import Loader from "../../partials/Loader";

const ViewImplementation = () => {
  const { boqs_proposed_id } = useParams();

  const [activeTab, setActiveTab] = useState("General Information");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const scrollRef = useRef(null);
  const [isLeftClicked, setIsLeftClicked] = useState(false);
  const [isRightClicked, setIsRightClicked] = useState(false);

  const scrollTabs = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      if (direction === "left") {
        setIsLeftClicked(true);
        setTimeout(() => setIsLeftClicked(false), 200);
      } else {
        setIsRightClicked(true);
        setTimeout(() => setIsRightClicked(false), 200);
      }
    }
  };

  // Fetch data for the selected implementation and feature
  useEffect(() => {
    const getImplementationFeatureDetails = async () => {
      try {
        setLoading(true);
        const response = await fetchData(
          `implementation-phase-details/feature/${boqs_proposed_id}`
        );

        
        setData(response.data);
      } catch (error) {
        console.error("Error fetching feature details:", error);
      } finally {
        setLoading(false);
      }
    };

    getImplementationFeatureDetails();
  }, [boqs_proposed_id]);

  if (loading) {
    return <Loader/>;
  }

  const tabs = [
    "General Information",
    "Feature Details",
    // "Implementation & Physical States",
    "Implementation & Physical Status",
    "Verification Checklist",
  ];

  return (
    <div>
      <h1 className="text-[1.475rem] text-black font-bold">
        View Implementation Phase
      </h1>

      <div className="mt-6 mb-8 ">
        {/* Navigation Tabs */}
        <div className="flex items-center rounded-t-lg bg-[#fdf5ec] relative">
          <button
            onClick={() => scrollTabs("left")}
            className={`text-xl px-4 py-2 font-bold rounded-lg transition-colors ${
              isLeftClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            «
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-hidden scrollbar-hide"
          >
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-10 py-2 font-semibold whitespace-nowrap ${
                  activeTab === tab ? "bg-[#caa316] text-white" : "text-black"
                }`}
                style={{
                  borderTopLeftRadius: "13px",
                  borderTopRightRadius: "30px",
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollTabs("right")}
            className={`ml-auto text-xl px-4 py-2 rounded-lg font-bold transition-colors ${
              isRightClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            »
          </button>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-b-lg shadow-md p-6">
          {activeTab === "General Information" && (
            <GeneralInformation data={data} />
          )}
          {activeTab === "Feature Details" && <FeatureDetails data={data} />}
          {activeTab === "Implementation & Physical Status" && (
            <ImplementationAndPhsyical data={data} />
          )}
        </div>
        {/* Tab Content */}
        <div className="bg-white rounded-b-lg shadow-md p-6">
          {activeTab === "Verification Checklist" && (
            <VerificationChecklist data={data} />
          )}
          {/* {activeTab === "Feature Details" && <FeatureDetails data={data} />}
          {activeTab === "Implementation & Physical Status" && (
            <ImplementationAndPhsyical data={data} />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default ViewImplementation;
